module.exports = __webpack_public_path__ + "img/ExpandAlt.ec9b3b63.svg";